import { lazy } from 'react'

// Route pages load on demand.
const SampleModules = {
    List: lazy(() => import('./components/List')),
}
export default SampleModules
